function normalizarNombrePaciente(value) {
  return String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLocaleUpperCase()
}

/**
 * Desde el portal titular se muestran los turnos propios y los de familiares
 * cuyo vínculo todavía no está confirmado. Los turnos de un portal familiar
 * activo se muestran sin aplicar este filtro.
 */
export function turnoVisibleParaPortalActivo(
  turno,
  { visualizandoFamiliar = false, vinculosFamiliares = [] } = {},
) {
  if (visualizandoFamiliar || turno?.esTurnoFamiliar !== true) return true

  const turnoFichaId = Number(turno?.fichaId)
  const turnoPaciente = normalizarNombrePaciente(turno?.pacienteDisplay)
  const perteneceAVinculoConfirmado = vinculosFamiliares.some((vinculo) => {
    if (vinculo?.confirmado !== true) return false

    const vinculoFichaId = Number(vinculo?.fichaFamiliarId)
    if (
      Number.isFinite(turnoFichaId)
      && turnoFichaId > 0
      && Number.isFinite(vinculoFichaId)
      && vinculoFichaId > 0
    ) {
      return turnoFichaId === vinculoFichaId
    }

    const vinculoPaciente = normalizarNombrePaciente(
      `${vinculo?.nombre ?? ''} ${vinculo?.apellido ?? ''}`,
    )
    return !!turnoPaciente && turnoPaciente === vinculoPaciente
  })

  return !perteneceAVinculoConfirmado
}
